<template>
    <v-card v-if="student" height="100" class="kimsa-elevation" :color="hasMessage ? 'backGroundSecondary' : ''"
            @click="clickCard">

        <v-row dense align="center">
            <v-col cols="3" :class="['img-student',{'background-img': !hasImg}]"
                   :style="{ backgroundImage: `url('${studentImg}')` }"/>
            <v-col cols="9" class="pa-0">
                <v-row class="px-3" align="center">
                    <v-col :cols="hasMessage ? '10' : '12'"
                           :class="['name-student text-truncate', hasMessage ? 'white--text' : '']">
                        {{ student.name }}
                    </v-col>
                    <v-col v-if="hasMessage" cols="2" :class="['name-student', hasMessage ? 'white--text' : '']">
                        <v-avatar size="15" color="primary" class="message-count">
                            1
                        </v-avatar>
                    </v-col>
                    <v-col cols="12" class="pt-1" v-if="student.sportSelected"
                           :class="['text-truncate', 'description-student', hasMessage ? 'white--text' : '']">
                        {{ student.sportSelected }}
                    </v-col>
                    <v-col v-if="student.objectives" cols="12" class="pt-1"
                           :class="['text-truncate', 'description-student', hasMessage ? 'white--text' : '']">
                        {{ joinObjectives }}
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

    </v-card>
</template>

<script>

import {db} from '@/utils/Firebase'

export default {
    props: {
        student: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            loading: true,
        }
    },
    mounted() {
        var vm = this
        // console.log(vm.student)
    },
    computed: {
        studentImg(vm = this) {
            if (!vm.student.avatar) return require('@/assets/img/logo.png')
            return vm.student.avatar
        },
        joinObjectives(vm = this) {
            var obj = vm.student.objectives
            if (obj.length === 1) return obj[0]
            if (obj.length === 2) return `${obj[0]}, ${obj[1]}`
            if (obj.length >= 3) return `${obj[0]}, ${obj[1]}...`
        },
        hasMessage(vm = this) {
            return false
        },
        hasImg(vm = this) {
            return vm.student.avatar
        }
    },
    methods: {
        clickCard() {
            var vm = this
            vm.$emit('click')
        }
    },
}
</script>

<style scoped>

.img-student {
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px 0 0 4px;
    height: 100px;
}

.name-student {
    color: #333333;
    font-weight: bold;
    font-size: 17px;
    padding-bottom: 0px;
}

.description-student {
    color: #333333;
    font-size: 13px;
    padding-top: 0px;
    padding-bottom: 0px;
}

.message-count {
    color: #333333;
    font-size: 10px;
}

.background-img {
    background-color: rgba(1, 55, 46, 0.03);
}

</style>